import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getEstadisticaPlanes = async (fechaStart , fechaEnd ) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/reportes/EstadisticaPlanes?empresa=${userInfo.empresa}&fechaStart=${fechaStart}&fechaEnd=${fechaEnd}`);
        console.log(" DATOS " + JSON.stringify(data));
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

export const getEstadisticaPlanesPartner = async (fechaStart , fechaEnd, idRecolector ) => {
    try {
      const userInfo = fetchUser();
      console.log(" ID RECOLECTOR " + idRecolector + " FECHAS " + fechaStart + " - " + fechaEnd + " EMPRESA " + userInfo.empresa  );
      const {data}  = await Axios.get(
        `/reportes/EstadisticaPlanesPartner?empresa=${userInfo.empresa}&fechaStart=${fechaStart}&fechaEnd=${fechaEnd}&idRecolector=${idRecolector}`);
        console.log(" DATOS " + data );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };


  export const getSolicitudesPorEstado = async (fechaStart , fechaEnd ) => {
  };


export const getRegistroEntregasCliente = async (fechaStart,fechaEnd , idCliente) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/reportes/EstadisticaEntregasCliente?empresa=${userInfo.empresa}&fechaStart=${fechaStart}&fechaEnd=${fechaEnd}&idCliente=${idCliente}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getResumenEquipos = async (fechaStart , fechaEnd ) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/reportes/ResumenEquipos?empresa=${userInfo.empresa}&fechaStart=${fechaStart}&fechaEnd=${fechaEnd}`);
       // console.log(" DATOS " + JSON.stringify(data));
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getResumenCostoMaquina = async (fechaStart , fechaEnd ) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/reportes/ResumenCentroMaquina?empresa=${userInfo.empresa}&fechaStart=${fechaStart}&fechaEnd=${fechaEnd}`);
       // console.log(" DATOS " + JSON.stringify(data));
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };